/* eslint-disable validate-jsx-nesting/no-invalid-jsx-nesting */
import { ServiceLogo } from '@on3/ui-lib/components/ServiceLogo/ServiceLogo';
import { Circle } from '@public/components/Circle/Circle';
import {
  AboutBlockMenu,
  InternalBlockMenu,
} from '@public/components/Menu/InternalBlockMenu';
import clsx from 'clsx';

import styles from './AboutPage.module.scss';

export const AboutPage = () => (
  <article className={styles.page}>
    <nav className={styles.menu}>
      <InternalBlockMenu list={AboutBlockMenu} />
    </nav>

    {/* About */}
    <section className={styles.aboutSection}>
      <div className={styles.sectionInner}>
        <h1 id="about">About On3</h1>
        <p>
          <strong>On3 Media</strong> is a leading sports media and technology
          company delivering trusted coverage and connectivity across youth,
          high school, college sports, and NIL.
        </p>
        <p>
          Our business is built around three core divisions, each serving a
          distinct role in the sports ecosystem:
        </p>
        <ul>
          <li>
            <strong>National Sports Media</strong> leadership anchored by{' '}
            <strong>On3</strong> (college, NIL, transfer portal) and{' '}
            <strong>Rivals</strong> (recruiting, high school).
          </li>
          <li>
            <strong>Fan Sites Network</strong>, the most extensive network of
            team-specific sites, insiders, and message board communities,
            serving the most passionate fans.
          </li>
          <li>
            <strong>Recruits</strong>, our athlete-driven platform, provides
            recruiting and NIL solutions for players, coaches, and brands.
          </li>
        </ul>
        <p>
          Together, these divisions—powered by media platforms, proprietary
          data, and strategic partnerships—connect fans, athletes, schools, and
          brands. We help athletes make smarter decisions, enable schools and
          brands to optimize resources and opportunities, and deliver impactful
          content and insight to sports communities nationwide.
        </p>
        <p>
          Founded in August 2021 and headquartered in Nashville, On3 Media has a
          fast-growing team of nearly 200 passionate professionals across 35
          states, all working to shape the future of sports media.
        </p>
        <p>
          <b>On3 HQ</b>
          <br />
          2970 Foster Creighton Drive
          <br />
          Nashville, TN 37204
        </p>
      </div>
    </section>

    {/* Measurables */}
    <section className={styles.measurablesSection}>
      <div className={styles.sectionInner}>
        <h2 id="measurables">Measurables</h2>
        <div className={styles.measurables}>
          <Circle strokePercent={33} subtitle="100+" title="Fan Sites" />
          <Circle
            strokePercent={40}
            subtitle="10M+"
            title="Social Media Followers"
          />
          <Circle
            strokePercent={18}
            subtitle="10.1M+"
            title="Monthly Unique Visitors"
          />
          <Circle strokePercent={11} subtitle="150+" title="Employees/Teams" />
        </div>
      </div>
    </section>

    {/* Origin */}
    <section className={styles.originSection}>
      <div className={styles.sectionInner}>
        <h2 id="origin">Origin</h2>
        <dl className={styles.timeline}>
          <div className={styles.timelineEvent}>
            <dt>2000</dt>
            <div className={styles.logoWrapper}>
              <ServiceLogo className={styles.logo} type="rivals" />
            </div>
            <dd>
              <ul>
                <li>Made recruiting media mainstream</li>
                <li>First network of Fan Sites</li>
                <li>
                  Acquired by Yahoo! <br /> 2008
                </li>
              </ul>
            </dd>
          </div>
          <div className={styles.timelineEvent}>
            <dt>2010</dt>
            <div className={styles.logoWrapper}>
              <ServiceLogo className={styles.logo} type="247" />
            </div>
            <dd>
              <ul>
                <li>Data-driven ratings and rankings</li>
                <li>Evolution of the player database</li>
                <li>Dual revenue model (ads + subscriptions)</li>
                <li>
                  Acquired by CBS Sports <br /> 2016
                </li>
              </ul>
            </dd>
          </div>
          <div className={styles.timelineEvent}>
            <dt>2021</dt>
            <div className={styles.logoWrapper}>
              <ServiceLogo
                className={clsx(styles.logo, styles.on3Logo)}
                type="on3"
              />
            </div>
            <dd>
              <ul>
                <li>Launched August 2021</li>
                <li>
                  Building the premier College Sports Media and Data Company
                </li>
              </ul>
            </dd>
          </div>
          <div className={styles.timelineEvent}>
            <dt>2025</dt>
            <div className={styles.logoWrapper}>
              <ServiceLogo className={styles.logo} type="rivals" />
            </div>
            <dd>
              <ul>
                <li>
                  On3 Media re-acquires Rivals, the leader in recruiting and
                  high school sports.
                </li>
              </ul>
            </dd>
          </div>
        </dl>
        <div className={styles.founder}>
          <div className={styles.founderAvatar}>
            <img
              alt="Founder of On3"
              height="150px"
              loading="lazy"
              src="https://on3static.com/static/on3/shannon-terry.jpg"
              width="150px"
            />
          </div>
          <div className={styles.founderName}>
            <h4>Shannon Terry</h4>
            <span>On3 Founder and CEO</span>
          </div>
          <ul>
            <li>
              25 years of successfully building digital media properties and
              large, endemic audiences
            </li>
            <li>Co-founded Rivals in 2000</li>
            <li>Founded 247Sports in 2010</li>
            <li>Founded Comicbook.com 2013, No.1 brand in geek media</li>
          </ul>
        </div>
      </div>
    </section>
  </article>
);
